import { all } from "redux-saga/effects";
import { getSubsidiariesWatcher } from "./getSubsidiaries.saga";
import {
    getGameEnginesWatcher,
    getEnginesSchemasWatcher
} from "./getGameEngines.saga";
import { getGameConfigurationsWatcher } from "./getGameConfigurations.saga";
//import { getGameConfigurationWatcher } from "./getGameConfiguration.saga";
import { getGamesWatcher, searchGamesWatcher } from "./getGames.saga";
import { editGameWatcher, createGameWatcher } from "./saveGame.saga";
import { getGameWatcher } from "./getGame.saga";
import {
    editConfigurationWatcher,
    createConfigurationWatcher,
    deleteConfigurationWatcher,
    activateConfigurationWatcher,
    moveConfigurationWatcher
} from "./saveConfiguration.saga";
import { getGameBundlesWatcher } from "./getGameBundles.saga";
import {
    createBundleWatcher,
    editBundleWatcher,
    deleteBundleWatcher
} from "./saveBundle.saga";
import { getSubsidiaryConfigurationsWatcher } from "./getSubsidiaryConfigurations.saga";
import { loadJsonWatcher, createAliasWatcher } from "./loadJson.saga";
import {
    getGameAttributesWatcher,
    getClientsWatcher,
    getGameFeaturesWatcher,
    getGameSeriesWatcher,
    getGamePlatformsWatcher,
    getGameTypesWatcher,
    getGameTrademarksWatcher,
    editGameAttributesWatcher,
    createGameAttributesWatcher,
    getGameCreationAttributesWatcher
} from "./getGameAttributes.saga";
import {getDenominationsWatcher} from "./getDenominations.saga";
import {
    getGameCategoriesWatcher,
    saveGameCategoryWatcher,
    deleteGameCategoryWatcher
} from "./getGameCategories.saga";


export default function* rootSaga() {
    yield all([
        getSubsidiariesWatcher(),
        getGameEnginesWatcher(),
        getGameConfigurationsWatcher(),
        //getGameConfigurationWatcher(),
        getEnginesSchemasWatcher(),
        getGamesWatcher(),
        editGameWatcher(),
        createGameWatcher(),
        getGameWatcher(),
        editConfigurationWatcher(),
        createConfigurationWatcher(),
        deleteConfigurationWatcher(),
        getGameBundlesWatcher(),
        createBundleWatcher(),
        editBundleWatcher(),
        deleteBundleWatcher(),
        getSubsidiaryConfigurationsWatcher(),
        loadJsonWatcher(),
        createAliasWatcher(),
        activateConfigurationWatcher(),
        searchGamesWatcher(),
        moveConfigurationWatcher(),
        getGameAttributesWatcher(),
        getClientsWatcher(),
        getGameFeaturesWatcher(),
        getGameSeriesWatcher(),
        getGamePlatformsWatcher(),
        getGameTypesWatcher(),
        getGameTrademarksWatcher(),
        editGameAttributesWatcher(),
        createGameAttributesWatcher(),
        getGameCreationAttributesWatcher(),
        getDenominationsWatcher(),
        getGameCategoriesWatcher(),
        saveGameCategoryWatcher(),
        deleteGameCategoryWatcher()
    ]);
}
